<template>
  <div class="payment-forms">
    <b-row>
      <!-- ICONE DE FECHAR -->
      <b-col class="remove-col" cols="12">
        <button class="remove-col--btn" @click="$emit('close-inputs')">
          <Icon icon="x-icon" />
        </button>
      </b-col>
    </b-row>

    <!-- TIPO DE COBRANÇA -->
    <div class="form--row ">
      <InputCheckbox
        v-for="paymentForm in hotelPaymentForms"
        v-model="fluctuationData.formasPagamento"
        :key="paymentForm.codigo"
        :checked="fluctuationData.formasPagamento?.includes(paymentForm.codigo)"
        :inputValue="paymentForm.codigo"
        :label="getPaymentLabel(paymentForm)"
        name="payment-form"
        class="form--input__checkbox"
      />
    </div>

    <div class="form--row form--row__margin">
      <InputCheckbox
        v-model="fluctuationData.formasPagamentoExclusivoFlutuacao"
        :checked="isExclusiveChecked"
        :disabled="!disableExclusiveFluctuation"
        :inputValue="true"
        :infoIcon="true"
        tooltipMinWidth="285"
        label="Usar apenas formas de pagamento selecionadas nesta tarifa"
        infoText="Selecionando esta opção, apenas as formas de pagamento selecionadas serão disponibilizadas. Se quiser usar também as padrões não selecione esta opção."
        name="onlySelectForms"
        class="form--input__checkbox"
      />
    </div>
  </div>
</template>

<script>
import InputCheckbox from '@solucoes/components-lib-tmp/src/components/elements/InputCheckbox'

export default {
  name: 'PaymentForms',
  components: {
    InputCheckbox
  },

  props: {
    fluctuationData: Object,

    pixCode: {
      type: Number,
      default: 0
    },

    onlyPix: {
      type: Boolean,
      default: false
    },

    hotelPaymentForms: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    disableExclusiveFluctuation() {
      const validPaymentForms = this.hotelPaymentForms.map(
        (form) => form.codigo
      )
      return this.fluctuationData.formasPagamento.some(
        (payment) =>
          validPaymentForms.includes(payment) && payment !== this.pixCode
      )
    },

    isExclusiveChecked() {
      if (this.disableExclusiveFluctuation === true) {
        return this.fluctuationData.formasPagamentoExclusivoFlutuacao
      } else if (!this.onlyPix) {
        this.setFormasPagamentoExclusivoFlutuacao(false)
        return false
      } else {
        return false
      }
    }
  },

  created() {
    if (!this.fluctuationData.formasPagamento?.length) {
      this.fluctuationData.formasPagamento = []
    }
  },

  methods: {
    setFormasPagamentoExclusivoFlutuacao(valor) {
      this.fluctuationData.formasPagamentoExclusivoFlutuacao = valor
    },

    getPaymentLabel(paymentForm) {
      let label = `${paymentForm.nome}`

      if (paymentForm.numeroParcelas > 1) {
        label += ` (até ${paymentForm.numeroParcelas}x`

        if (paymentForm.valorMinimoParcela) {
          label += ` - mín, R$ ${paymentForm.valorMinimoParcela},00`
        }

        label += ')'
      }

      return label
    }
  }
}
</script>

<style scoped lang="scss">
.payment-forms {
  border: 1px solid pmw-colors(grey-20);
  padding: 12px 21px;
  margin-top: 25px;
  width: 100%;
}

.remove-col {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;

  &--btn {
    @include reset-button();

    .icon {
      width: 12px;
      height: 12px;
      color: $gray-dark;
      transition: color 0.8s;

      &:hover {
        color: red;
      }
    }
  }
}
.form {
  &--button {
    width: 100px;
  }

  &--item {
    font-size: font-size('size-medium');

    b {
      font-weight: font-weight('weight-medium');
    }
  }

  &--title {
    font-size: font-size('size-medium');
    font-weight: font-weight('weight-normal');
    line-height: 21px;

    &__bold {
      font-size: font-size('size-medium');
      font-weight: font-weight('weight-medium');
      line-height: 21px;
    }
  }

  &--row {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 24px;
    margin-bottom: 12px;

    &__margin {
      margin-bottom: 12px;
      margin-top: 25px;
    }
  }

  &--input {
    &__checkbox {
      width: auto;

      ::v-deep {
        .input-checkbox--label__overflow {
          overflow: visible;
        }
      }
    }

    &-select {
      ::v-deep {
        .pmw-select--button__caret-sort-up,
        .pmw-select--button__show {
          border-bottom-color: pmw-colors('blue-100');
        }
        .pmw-select--button:focus {
          border-color: pmw-colors('blue-100');
          border-bottom-color: pmw-colors('blue-100');
        }
        .pmw-select-options--item__hover:hover,
        .pmw-select-options--item__checked {
          background-color: pmw-colors('blue-100') !important;
        }

        .pmw-label {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .pmw-form-field--label {
          font-weight: font-weight('weight-medium');
        }
      }
    }

    &-normal {
      width: 145px;

      ::v-deep {
        .pmw-form-field--label {
          font-weight: font-weight('weight-medium');
        }
        .form-field--label-wrapper {
          line-height: 21px;
          margin-bottom: 3px;
        }
        .pmw-input {
          background: $white;
        }
        .pmw-input--clear {
          z-index: 0;
        }
        .pmw-input__focus {
          border-color: $pmw-blue;
        }

        .pmw-input--field {
          background: $pmw-white;

          &:focus {
            border-color: $pmw-blue;
          }
        }

        .pmw-input__disabled {
          input {
            background: pmw-colors('grey-20');
            color: $pmw-gray-darker;
          }
        }

        .pmw-custom-tooltip {
          line-height: 18px;
        }
      }
    }

    &__large {
      width: 145px;
    }

    &__medium {
      width: 125px;
    }

    &__small {
      width: 95px;
    }
  }
}
</style>
